import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import {

  GetCountryList,
  GetTimezone,
  CheckReferralCode,
  VerifyOTP,
  RegisterUserNewApi,
  CheckUserExists,
  GenerateOTP,
  GetLocationDetails,
} from "../api/_request";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";


import EmailInput from "./inputs/emailInput";

import ReferralInput from "./inputs/referralInput";
import CountrySelector from "./selectors/countrySelector";
import TimzoneSelector from "./selectors/timzoneSelector";
import TncAgreeSwitch from "./switch/tncAgreeSwitch";
import OtpVerifierInput from "./inputs/otpVerifierInput";
import { useAppState } from "../context/AppStateContext";
import { ActionTypes } from "../reducer/actionTypes";
import {
  countriesJSON,
  formatTime,
  getDeviceId,
  getDeviceType,
  isEmailValid,
  isNameValid,
  isPhoneValid,
  setCookieOnClientSide,
  validatePhoneNumber,
} from "../lib/utils";
import Drawer from "./ui/drawer";
import LoginButton from "./buttons/loginButton";
import PhoneNumberInput from "./inputs/phoneNumberInput";
import FullNameInput from "./inputs/fullNameInput";
import { isValidPhoneNumber } from "libphonenumber-js";
import { PhoneInput } from "./inputs/phoneNumberAlt";
import CountryAutocomplete from "./autocomplete/countryAutocomplete";

const UserRegisterForm = () => {
  const { state, dispatch } = useAppState();

  const isAskSamHost =
    window.location.host.includes(".ask-sam.ai") ||
    window.location.host.includes(".asksam.com.au");

  //Intl.DateTimeFormat().resolvedOptions().timeZone

  //STATES
  const [formData, setFormData] = useState<FormDataInterface>({
    email: "",
    fullName: "",
    firstName: "",
    lastName: "",
    title: "`",
    referralCode: "",
    selectedCountry: "",
    selectedTimezone: "",
    isTermsAccepted: false,
    socialID: null,
    socialType: null,
    mobileNo: "",
    userType: 4,
    countryID: "",
    userId: "",
    institutionId: "1",
    referenceId: "",
    groupId: "",
    device_type: "",
    device_id: "",
  });
  const [step, setStep] = useState<number>(0);
  const [errors, setErrors] = useState<FormErrors>({
    email: "",
    fullName: "",
    referralCode: "",
    otp: "",
    mobileNo: "",
  });
  const [countries, setCountries] = useState<any>([]);
  const [timezoneList, setTimezoneList] = useState<any>(null);
  const [disableRegister, setDisableRegister] = useState<boolean>(true);
  const [isOTPServiceCalled, setIsOTPServiceCalled] = useState<boolean>(false);
  const [isRegisterServiceCalled, setIsRegisterServiceCalled] =
    useState<boolean>(false);
  const [counter, setCounter] = useState<number>(30);
  const [otp, setOtp] = useState<string>("");

  const [verifyOTPCounter, setVerifyOTPCounter] = useState<number>(0);
  const [openWarningDialog, setOpenWarningDialog] = useState<boolean>(false);
  const [userCountry, setUserCountry] = useState<string>("");
  const [geoIPCountry, setGeoIPCountry] = useState<string | null>(null);
  const [geoIPTimeZone, setGeoIPTimeZone] = useState<string | null>(null);

  const searchBarParams = new URLSearchParams(window.location.search);
  const redirectURL = searchBarParams.get("redirect");
  const utmSource = searchBarParams.get("utm_source");
  const utmMedium = searchBarParams.get("utm_medium");
  const utmCampaign = searchBarParams.get("utm_campaign");
  const utmID = searchBarParams.get("utm_id");

  //console.log("userCountry", userCountry)
  const validEmailRegex = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
  ///UseEffect Region Start

  //Single Run useEffect
  useEffect(() => {
    getIPDetails();
  }, []);

  //Set Full Name in FormData
  useEffect(() => {
    setFormData((prevData: any) => ({
      ...prevData,
      fullName: `${formData?.firstName} ${formData.lastName}`,
    }));
  }, [formData.firstName, formData.lastName]);

  //Counter for Resend OTP
  useEffect(() => {
    let timer: string | number | NodeJS.Timeout | undefined;
    if (step === 1) {
      if (counter > 0) {
        timer = setTimeout(() => setCounter(counter - 1), 1000); // Decrease counter every second
      } else if (counter === 0) {
        //setResendAllowed(true); // Enable resend button when countdown reaches 0
      }
    }
    return () => clearTimeout(timer);
  }, [step, counter]);

  //Too many attempts Counter
  useEffect(() => {
    let timer: string | number | NodeJS.Timeout | undefined;

    if (verifyOTPCounter > 0) {
      timer = setTimeout(() => setVerifyOTPCounter(verifyOTPCounter - 1), 1000); // Decrease counter every second

      if (step == 0) {
        setErrors((prevData: any) => ({
          ...prevData,
          email: `Too many OTP requests. Please wait ${verifyOTPCounter} seconds before trying again.`,
        }));
      }
      if (step == 1) {
        setErrors((prevData: any) => ({
          ...prevData,
          otp: `Incorrect OTP. Please wait ${formatTime(
            verifyOTPCounter
          )} minutes before attempting again.`,
        }));
      }
    } else if (verifyOTPCounter === 0) {
      //setResendAllowed(true); // Enable resend button when countdown reaches 0
      setErrors((prevData: any) => ({ ...prevData, otp: "" }));
    }

    return () => clearTimeout(timer);
  }, [verifyOTPCounter]);

  //Disable Button Logic
  useEffect(() => {
    const { email, fullName, referralCode, mobileNo } = errors;

    const { isTermsAccepted } = formData;

    const phoneNumberValidation =
      isPhoneValid(
        formData?.mobileNo!,
        isAskSamHost,
        formData?.selectedCountryCode!
      ) === true
        ? true
        : false;

    /*if (
      email === "" &&
      fullName === "" &&
      referralCode === "" &&
      mobileNo === "" &&
      isTermsAccepted &&
      formData?.email &&
      isEmailValid(formData?.email) &&
      formData?.fullName &&
      isNameValid(formData?.fullName)
    ) {
      setDisableRegister(false);
    } else {
      setDisableRegister(true);
    }*/

    const canRegister =
      email === "" &&
      fullName === "" &&
      mobileNo === "" &&
      referralCode === "" &&
      isTermsAccepted &&
      formData?.email &&
      isEmailValid(formData?.email) &&
      formData?.fullName &&
      isNameValid(formData?.fullName) &&
      formData.specialization !== "";

    const canAURegister = canRegister && phoneNumberValidation;

    // Determine whether to enable or disable the button
    const shouldEnable =
      (!isAskSamHost && canRegister) || (isAskSamHost && canAURegister);

    setDisableRegister(!shouldEnable);
  }, [errors, formData]);

  //Full Name check
  useEffect(() => {
    const {
      email,
      fullName,
      isTermsAccepted,
      selectedCountry,
      selectedTimezone,
      mobileNo,
      selectedCountryCode,
    } = formData;

    // Helper function to check if a field is valid
    const isValidField = (field: string) =>
      field !== undefined && field !== null && field.trim() !== "";

    // Validate email
    const isEmailValid =
      email &&
      isValidField(email) &&
      email?.toLowerCase().match(validEmailRegex);

    // Validate full name
    const isNameValid =
      fullName && isValidField(fullName) && fullName.trim().length >= 3;

    // Validate phone number
    const isPhoneValid = isAskSamHost
      ? mobileNo &&
        isValidField(mobileNo) &&
        validatePhoneNumber(mobileNo, selectedCountryCode)
      : true;

    //console.log("isPhoneValid", isPhoneValid);

    // Validate country and timezone selection
    const isCountryValid = selectedCountry && isValidField(selectedCountry);
    const isTimezoneValid = selectedTimezone && isValidField(selectedTimezone);

    // Check if all conditions for enabling the button are met
    // const canRegister =
    //   isEmailValid &&
    //   isNameValid &&
    //   isTermsAccepted &&
    //   isCountryValid &&
    //   isTimezoneValid &&
    //   isPhoneValid;

    const canRegister =
      isEmailValid && isNameValid && isTermsAccepted && isPhoneValid;
    //console.log("canRegister", canRegister)
    // setDisableRegister(!canRegister);

    // Update errors
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      // Show error for full name when typing starts
      if (
        fullName &&
        fullName?.trim().length > 0 &&
        fullName.trim().length < 3
      ) {
        updatedErrors.fullName = "Name must have at least 3 characters";
      } else if (fullName && fullName.trim() === "") {
        updatedErrors.fullName = ""; // Clear error if the field is empty
      } else {
        updatedErrors.fullName = ""; // Clear error if validation passes
      }

      // Error for mobile number
      if (isAskSamHost) {
        if (!mobileNo || mobileNo.trim() === "") {
          // Clear error when mobile number is empty
          updatedErrors.phoneNumber = "";
        } else if (
          !isValidField(mobileNo) ||
          !validatePhoneNumber(mobileNo, selectedCountryCode)
        ) {
          updatedErrors.phoneNumber = "Invalid mobile number!";
        } else {
          updatedErrors.phoneNumber = "";
        }
      } else {
        if (
          mobileNo &&
          mobileNo?.length > 0 &&
          !validatePhoneNumber(mobileNo, selectedCountryCode)
        ) {
          updatedErrors.mobileNo = "Invalid mobile number!";
        } else {
          updatedErrors.mobileNo = "";
        }
      }

      return updatedErrors;
    });
  }, [formData, isAskSamHost]);

  //Get Country list
  useEffect(() => {
    getCountryList();
  }, []);

  //Handle Mobile number based on Selected Country
  useEffect(() => {
    if (!isAskSamHost) {
      //getDefaultPhoneNumber()
    }

    if (formData.selectedCountry == "IN") {
      setFormData((prevData) => ({
        ...prevData,
        selectedTimezone: "Asia/Kolkata",
      }));
    }

    if (formData.selectedCountry !== "") {
      getTimezoneList();
    } else {
      setTimezoneList(null);
    }
  }, [formData.selectedCountry, isAskSamHost]);

  //Handle Timezone for countries which have only one Timezone
  useEffect(() => {
    if (timezoneList !== null && timezoneList.length == 1) {
      setFormData((prevData) => ({
        ...prevData,
        selectedTimezone: timezoneList[0].name,
      }));
    }
  }, [timezoneList]);

  //Handle Autosend OTP
  // useEffect(() => {
  //   if (otp.length === 4) {
  //     setDisableRegister(false);
  //     handleRegisterUser();
  //   } else {
  //     setDisableRegister(true);
  //   }
  // }, [otp]);

  ///UseEffects Region End
  // console.log("formData", formData);
  ///Functions Region Start
  const getDefaultPhoneNumber = () => {
    if (formData.selectedCountry === "IN") {
      setFormData((prevData) => ({
        ...prevData,
        mobileNo: "+91 0000000000",
      }));
    } else if (formData.selectedCountry === "CA") {
      setFormData((prevData) => ({
        ...prevData,
        mobileNo: "+1 0000000000",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        mobileNo: "+00 0000000000",
      }));
    }
  };

  const getIPDetails = async () => {
    try {
      const ipDetails = await GetLocationDetails();

      if (ipDetails?.status === 200) {
        const ipTimezone = ipDetails?.data?.data?.timezone;
        const ipCountry = ipDetails?.data?.data?.country;
        const ipRegion = ipDetails?.data?.data?.region;
        const ipCity = ipDetails?.data?.data?.city;
        const ipPostalCode = ipDetails?.data?.data?.postalCode;
        // console.log("ipCountry ===> ", ipCountry);

        //Set Phonecode based on selected country
        const formattedData = countriesJSON.filter(
          (item) => item.iso2 === ipCountry
        );
        const formattedCountry = formattedData[0]?.name;
        setUserCountry(ipCountry);
        setFormData((prevData: any) => ({
          ...prevData,
          selectedCountry: formattedCountry,
          selectedCountryCode: ipCountry,
          selectedRegion: ipRegion,
          selectedCity: ipCity,
          selectedTimezone: ipTimezone,
          selectedPostalCode: ipPostalCode,
          phoneCode: formattedData[0].phone_code,
        }));
        setGeoIPCountry(ipCountry);
        setGeoIPTimeZone(ipTimezone);
      }
    } catch (error) {}
  };

  const getCountryList = async () => {
    try {
      const res = await GetCountryList();

      //console.log("LIST", res.data.countries);
      setCountries(res.data.countries);
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    }
  };

  const getTimezoneList = async () => {
    const reqBody = {
      code: formData.selectedCountry,
    };
    try {
      const res = await GetTimezone(reqBody);

      //console.log("LIST", res.data.timezones);
      setTimezoneList(res.data.timezones);
    } catch (error) {
      toast.error("Something went wrong! Please try again.");
    }
  };

  const handleFormData = (
    field: string,
    value: string | number | null | boolean
  ) => {
    // console.log("value", value)
    let countryID: any = null;
    let selectedTimezone: any = null;
    if (field === "selectedCountry" && value !== "") {
      countryID = countries.filter((item: any) => item.code == value)[0].id;
      if (+countryID === 104) {
        selectedTimezone = "Asia/Kolkata";
      }
      //console.log("countryID", countryID);
    }

    if (countryID) {
      setFormData((prevData) => ({
        ...prevData,
        selectedTimezone,
        countryID,
        [field]: value,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }
  };

  const handleSendOTP = async (e?: any) => {
    e.preventDefault();
    setIsOTPServiceCalled(true);
    const isOTPVerified = await GenerateOTP({
      email: formData?.email?.toLocaleLowerCase(),
      host: window.location.host,
    });

    if (+isOTPVerified?.data?.code === 200) {
      setCounter(30);
      setErrors((prevData: any) => ({
        ...prevData,
        otp: "",
      }));
      toast.success("OTP sent successfully!");
    } else if (+isOTPVerified?.data?.code === 401) {
      // toast.error(isOTPVerified?.data.message);

      setErrors((prevData: any) => ({
        ...prevData,
        otp: isOTPVerified?.data?.message,
      }));

      if (+isOTPVerified?.data?.data?.retry_after) {
        setVerifyOTPCounter(+isOTPVerified?.data?.data?.retry_after);
        //  setOpenWarningDialog(true);
      }
    } else if (+isOTPVerified?.data?.code === 429) {
      // toast.error(isOTPVerified?.data.message);

      setErrors((prevData: any) => ({
        ...prevData,
        otp: isOTPVerified?.data.message,
      }));

      if (+isOTPVerified?.data?.data?.retry_after) {
        setCounter(+isOTPVerified?.data?.data?.retry_after);
        setVerifyOTPCounter(+isOTPVerified?.data?.data?.retry_after);
        //  setOpenWarningDialog(true);
      }
    } else {
      toast.error("Something went wrong! Please try again.");
      setErrors((prevData: any) => ({
        ...prevData,
        otp: "",
      }));
    }
    setIsOTPServiceCalled(false);
    setOtp("");
  };

  const handleCheckRegister = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();

    setDisableRegister(true);

    const isEmailAlreadyRegistered = await CheckUserExists(
      formData?.email?.toLocaleLowerCase(),
      "user"
    );

    const handleErrors = (field: string, message: string) => {
      setErrors((prevData) => ({
        ...prevData,
        [field]: message,
      }));

      setDisableRegister(false);
    };

    if (formData.referralCode) {
      const isReferralCodeValid = await checkReferrealCodeResponse();
      if (!isReferralCodeValid) {
        return handleErrors("referralCode", "Referral code is not valid!");
      }
    }

    if (isEmailAlreadyRegistered) {
      setIsOTPServiceCalled(false);
      return handleErrors(
        "email",
        "This email is already registered. Please try logging in!"
      );
    }

    if (geoIPCountry) {
      //Generate OTP
      handleSendOTP(e);
      //Go to validate OTP
      setStep(1);
    } else {
      setStep(9);
    }
  };

  const checkReferrealCodeResponse = async () => {
    try {
      const res = await CheckReferralCode(formData?.referralCode);
      if (res?.ResponseCode === 200) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      toast("Something went wrong! Please try again.");
    }
  };

  const handleRegisterUser = async (e?: any) => {
    try {
      e?.preventDefault();

      let mobileNumber;

      if (!isAskSamHost && formData?.mobileNo === "") {
        mobileNumber = formData.phoneCode + " 0000000000";
      } else {
        mobileNumber = `${formData.phoneCode} ${formData?.mobileNo}`;
      }

      const reqBody = {
        email: formData?.email?.toLocaleLowerCase(),
        //Title: formData?.title,
        name: formData?.fullName,
        phone: mobileNumber,
        referral_code: formData?.referralCode?.toLocaleUpperCase(),
        country: formData?.selectedCountry,
        // UserType: formData?.userType,
        time_zone: formData?.selectedTimezone,
        social_id: formData?.socialID,
        social_type: formData?.socialType,
        device_type: getDeviceType(),
        device_id: getDeviceId(),
      };
      //console.log("reqBody", reqBody);
      const isRegistrationComplete = await RegisterUserNewApi(reqBody);

      if (+isRegistrationComplete?.data?.code === 200) {
        const TOKEN = isRegistrationComplete?.data?.data?.token;
        const USERID = isRegistrationComplete?.data?.data?.user_id;
        const USERROLE = isRegistrationComplete?.data?.data?.role;
        const USERJWT = isRegistrationComplete?.data?.data?.jwt;

        //Set Cookie when registration is completed
        const setCookieBody: SetCookieInterface = {
          token: TOKEN,
          userID: USERID,
          userDataJwt: USERJWT,
          utmCampaign,
          utmMedium,
          redirectURL,
          type: "USER",
          regRef: "uwc_user_reg",
          method: "email",
          event: "uwc_register",
          authUserRole: USERROLE,
          provider: formData?.email?.toLocaleLowerCase()?.split("@")[1],
          displayName: formData?.firstName,
        };

        setCookieOnClientSide(setCookieBody);
      } else {
        toast.error("Something went wrong! Please try again.");
        setIsRegisterServiceCalled(false);
      }
    } catch (error) {}
  };

  const handleVerifyUser = async (e: any) => {
    e.preventDefault();

    setIsRegisterServiceCalled(true);

    const isOTPVerified = await VerifyOTP(
      formData?.email?.toLocaleLowerCase(),
      +otp
    );

    const { code, message, data } = isOTPVerified?.data;

    if (+code === 200) {
      if (isAskSamHost && formData?.mobileNo?.trim() === "") {
        getDefaultPhoneNumber();
      }

      handleRegisterUser();
    } else if (+code === 401) {
      //toast.error(isOTPVerified?.data.message);

      setErrors((prevData: any) => ({
        ...prevData,
        otp: message,
      }));

      if (+data?.retry_after) {
        setVerifyOTPCounter(+data?.retry_after);
        //setOpenWarningDialog(true);
      }
      setIsRegisterServiceCalled(false);
    } else if (+code === 429) {
      //toast.error(isOTPVerified?.data.message);

      setErrors((prevData: any) => ({
        ...prevData,
        otp: message,
      }));

      if (+data?.retry_after) {
        setCounter(+data?.retry_after);
        setVerifyOTPCounter(+data?.retry_after);
        //setOpenWarningDialog(true);
      }
      setIsRegisterServiceCalled(false);
    } else {
      toast.error(
        "Oops! Something went wrong. Please try requesting the OTP again later."
      );
      setIsRegisterServiceCalled(false);
    }

    setOtp("");
  };

  const handleCloseDialog = () => {
    setOpenWarningDialog(false);
  };

  const getComputedStyleVariable = (variable: string) => {
    return getComputedStyle(document.documentElement)
      .getPropertyValue(variable)
      .trim();
  };

  const primaryColorValue = getComputedStyleVariable("--primary");
  const rgbaColor = primaryColorValue
    ? `rgba(${parseInt(primaryColorValue.slice(1, 3), 16)}, ${parseInt(
        primaryColorValue.slice(3, 5),
        16
      )}, ${parseInt(primaryColorValue.slice(5, 7), 16)}, 0.48)` // Adjust the alpha value as needed
    : "";

  ///Functions Region End

  // console.log("formData", formData);

  return (
    <>
      {step === 0 && (
        <div>
          <h6 className="mt-1 text-center text-base">
            Sign up with your email address
          </h6>
          <form id={"user_reg_step1"} className="flex flex-col gap-1 mt-5">
            <EmailInput
              value={formData.email}
              handleFormData={handleFormData}
              error={errors.email}
              setErrors={setErrors}
            />

            {/* <UserNameInput
              firstNameVal={formData.firstName}
              lastNameVal={formData.lastName}
              handleFormData={handleFormData}
              error={errors.fullName}
              isLastNameRequired={isLastNameRequired}
            /> */}

            <FullNameInput
              fullNameVal={formData?.fullName?.trimStart()}
              handleFormData={handleFormData}
              error={errors.fullName}
            />
            {/* <PhoneInput /> */}
            {/* <CountryAutocomplete /> */}
            <PhoneNumberInput
              value={formData.mobileNo}
              phoneCode={formData?.phoneCode}
              countryCode={formData?.selectedCountry}
              handleFormData={handleFormData}
              setErrors={setErrors}
              error={errors.mobileNo}
              isPhoneRequired={isAskSamHost}
              isValid={validatePhoneNumber(
                formData?.mobileNo,
                formData?.selectedCountryCode
              )}
            />

            <ReferralInput
              referralCode={formData.referralCode}
              error={errors?.referralCode}
              setErrors={setErrors}
              handleFormData={handleFormData}
            />

            <div className="mt-3">
              <TncAgreeSwitch
                handleFormData={handleFormData}
                isTermsAccepted={formData?.isTermsAccepted}
                userCountry={userCountry}
              />
            </div>

            <button
              style={{
                backgroundColor: disableRegister ? rgbaColor : "var(--primary)",
              }}
              className="sendOTP mt-5"
              disabled={disableRegister}
              onClick={(e) => handleCheckRegister(e)}
            >
              {isOTPServiceCalled && (
                <Loader2 className="animate-spin h-5 w-5 mr-3" />
              )}
              Continue
            </button>
          </form>

          <div className="text-sm text-center text-slate-900 font-semibold mt-6">
            Already have an account? &nbsp;
            <LoginButton redirectURL={redirectURL} type="INLINE" />
          </div>
        </div>
      )}

      {step == 9 && (
        <>
          <h6 className="mt-1  text-center text-base">
            Please select your country and timezone
          </h6>
          <div className="flex flex-col gap-2 mt-5">
            <CountrySelector
              handleFormData={handleFormData}
              countries={countries}
            />
            {timezoneList && timezoneList?.length > 1 && (
              <TimzoneSelector
                handleFormData={handleFormData}
                timezoneList={timezoneList}
              />
            )}
          </div>

          <button
            style={{
              backgroundColor:
                formData?.selectedCountry === "" &&
                (formData?.selectedTimezone === "" ||
                  formData?.selectedTimezone === null)
                  ? rgbaColor
                  : "var(--primary)",
            }}
            className="sendOTP mt-5 w-full"
            disabled={
              formData?.selectedCountry === "" ||
              formData?.selectedTimezone === "" ||
              formData?.selectedTimezone === null
            }
            onClick={(e) => setStep(1)}
          >
            {/* {isOTPServiceCalled && (
                <Loader2 className="animate-spin h-5 w-5 mr-3" />
              )} */}
            Continue
          </button>
        </>
      )}

      {step === 1 && (
        <div className="">
          <h6 className="mt-1  text-center text-base">
            Please enter One Time Password (OTP) sent to your email.
          </h6>
          <div className="flex flex-col gap-2 mt-5">
            <OtpVerifierInput
              otp={otp}
              setOtp={setOtp}
              error={errors.otp}
              setErrors={setErrors}
              counter={verifyOTPCounter}
              id={"user_reg_step2"}
            />

            {verifyOTPCounter === 0 && (
              <div className="mt-5 flex flex-col gap-3">
                {counter > 0 ? (
                  <span className="flex-1 text-sm font-medium text-center text-slate-400 h-9 px-4 py-2">
                    Resend OTP in {counter}s
                  </span>
                ) : (
                  <button className="resendOTP" onClick={handleSendOTP}>
                    Resend OTP
                  </button>
                )}

                <button
                  style={{
                    backgroundColor:
                      otp.length !== 4 || isRegisterServiceCalled
                        ? rgbaColor
                        : "var(--primary)",
                  }}
                  onClick={handleVerifyUser}
                  className="sendOTP"
                  disabled={otp.length !== 4 || isRegisterServiceCalled}
                >
                  {isRegisterServiceCalled && (
                    <Loader2 className="animate-spin h-5 w-5 mr-3" />
                  )}
                  Verify OTP
                </button>
              </div>
            )}
          </div>

          {isRegisterServiceCalled ? (
            <div className="fixed w-full h-full top-0 left-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-20">
              <Loader2 className="animate-spin h-10 w-10 text-white" />
            </div>
          ) : null}
        </div>
      )}

      <Drawer
        isOpen={openWarningDialog}
        onClose={handleCloseDialog}
        counter={verifyOTPCounter}
      />
    </>
  );
};

export default UserRegisterForm;
